import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GoalHelpers, GoalService } from '@EYN/components';
import { Observable } from 'rxjs/internal/Observable';
import { first, map } from 'rxjs/operators';

@Injectable()
export class CanAccessPlanCalculatorGuard implements CanActivate {
	constructor(private goalService: GoalService) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.goalService.withRouteConfig()
			.pipe(first(), map(([{ overviewRoute }, goal]) => {
				const planId = +route.params.planId || GoalHelpers.getDefaultPlan(goal).planType;
				
				const plan = goal.plans.find(goalPlan => goalPlan.planType === planId);
				if (plan && this.goalService.isPlanStarted(plan)) {
					this.goalService.gotToSummaryPage();
					return false;
				} else if (plan && !this.goalService.isPlanStarted(plan)) {
					return true;
				} else {
					this.goalService.goToOverviewPage();
					return false;
				}
			}));
	}
}
